import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models/ServiceResponse'

export interface IEventGroupGetQuery {
  from?: string;
  to?: string;
  team_id?: number;
  player_id?: number;
  coach_id?: number;
}

export interface IEventGroup {
  id?: number;
  title: string;
  description?: string;
  start_date: string;
  end_date: string;
  type: string;
  organisation_id?: number;
}

export class EventGroupApiService extends ApiService {
  /**
   * Get all event groups
   *
   * @param query Optional query parameters including date range
   */
  static async getAll(query?: IEventGroupGetQuery): Promise<IServiceResponse<IEventGroup[]>> {
    return this.axios.get('event-groups', { params: query })
      .then((response: AxiosResponse<IServiceResponse<IEventGroup[]>>) => response.data)
  }

  /**
   * Get a specific event group by ID
   *
   * @param id
   */
  static async get(id: number): Promise<IServiceResponse<IEventGroup>> {
    return this.axios.get(`event-groups/${id}`)
      .then((response: AxiosResponse<IServiceResponse<IEventGroup>>) => response.data)
  }

  /**
   * Create a new event group
   *
   * @param data
   */
  static async create(data: IEventGroup): Promise<IServiceResponse<IEventGroup>> {
    return this.axios.post('event-groups', data)
      .then((response: AxiosResponse<IServiceResponse<IEventGroup>>) => response.data)
  }

  /**
   * Update an existing event group
   *
   * @param id
   * @param data
   */
  static async update(id: number, data: IEventGroup): Promise<IServiceResponse<IEventGroup>> {
    return this.axios.put(`event-groups/${id}`, data)
      .then((response: AxiosResponse<IServiceResponse<IEventGroup>>) => response.data)
  }

  /**
   * Delete an event group
   *
   * @param id
   */
  static async delete(id: number): Promise<AxiosResponse> {
    return this.axios.delete(`event-groups/${id}`)
  }

  /**
   * Get media for an event group
   *
   * @param id
   */
  static async getMedia(id: number, params?: object): Promise<IServiceResponse<object[]>> {
    return this.axios.get(`event-groups/${id}/media`, { params })
      .then((response: AxiosResponse<IServiceResponse<object[]>>) => response.data)
  }

  /**
   * Get notes for an event group
   *
   * @param id
   * @param params
   */
  static async getNotes(id: number, params?: object): Promise<IServiceResponse<object[]>> {
    return this.axios.get(`event-groups/${id}/notes`, { params })
      .then((response: AxiosResponse<IServiceResponse<object[]>>) => response.data)
  }

  /**
   * Create a note on an event group
   *
   * @param id
   * @param data
   */
  static async submitNote(id: number, data: object): Promise<IServiceResponse<object>> {
    return this.axios.post(`event-groups/${id}/note`, data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }
}
